import React from 'react';
import PropTypes from 'prop-types';
import SignatureBlockFields from './SignatureBlockFields';
import Formsy from 'formsy-react';
import { Button } from 'semantic-ui-react';
import { DeleteConfirmation, GlobalNotifications, Intent, MobileModal } from '../../../Modules';

export default class SignatureBlockEditMobile extends React.Component {

  static propTypes = {
    closeHandler: PropTypes.func.isRequired,
    closeEditor: PropTypes.func,
    commitUpdate: PropTypes.func.isRequired,
    delete: PropTypes.func,
    localSignatureBlock: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    isTemplate: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    isNew: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      submitted: false
    };
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.delete = this.delete.bind(this);
  }

  componentWillUnmount() {
    if (this.props.closeEditor) this.props.closeEditor();
  }

  onValidSubmit() {
    this.setState({ submitted: true });
    this.props.commitUpdate(this.props.index, () => this.props.closeHandler());
  }

  onInvalidSubmit() {
    this.setState({ submitted: true });
    GlobalNotifications.show({
      message: 'Unable to update signature block',
      intent: Intent.DANGER
    });
  }

  reset() {
    this.props.reset(this.props.index);
    setTimeout(() => this.props.closeHandler(), 0);
  }

  delete(e) {
    e.preventDefault();
    this.props.delete(this.props.index, () => this.props.closeHandler);
  }

  render() {
    const deleteButton = (
      <Button negative fluid type='button'>
        Delete Signature Block
      </Button>
    );

    return (
      <Formsy.Form ref='form' onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit}>
        <MobileModal
          open={this.props.open}
          onClose={this.props.closeHandler}
          inline
        >
          <MobileModal.Header>
            <div className='menu'>
              <a className='item' onClick={this.reset}>
                Cancel
              </a>
            </div>
            <div className='right menu'>
              <a className='item' onClick={() => this.refs.form.submit()}>
                Save
              </a>
            </div>
          </MobileModal.Header>
          <MobileModal.Content>
            <div style={{ padding: '0 2em' }}>
              <SignatureBlockFields
                localSignatureBlock={this.props.localSignatureBlock}
                onChange={this.props.onChange}
                submitted={this.state.submitted}
                isTemplate={this.props.isTemplate}
              />
              {this.props.delete && !this.props.isNew &&
                <div>
                  <div style={{ flex: 1 }}></div>
                  <div style={{ textAlign: 'center', marginTop: '2em' }}>
                    <DeleteConfirmation trigger={deleteButton} delete={this.delete} id={this.props.localSignatureBlock.id} />
                  </div>
                </div>
              }
            </div>
          </MobileModal.Content>
        </MobileModal>
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/SignatureBlocks/SignatureBlockEditMobile.js